import {Progress, Tooltip} from 'antd';
import {useMemo} from 'react';

import {appRoute} from '../../../../../../app-route';
import {Text} from '../../../../../../component/text/text';
import {gray1} from '../../../../../../css/var-export.scss';
import * as cssVariablesStyles from '../../../../../../css/var-export.scss';
import {NavigationLink} from '../../../../../../layout/navigation-link/navigation-link';
import {Locale} from '../../../../../../provider/locale/localization';

import {LpsStatus} from './lps-status/lps-status';
import * as styles from './lps-column.scss';

type LpsColumnPropsType = {
    value: number;
    averageLps?: number;
    isError?: boolean;
    shouldShowDash?: boolean;
};

export function LpsColumn({value, averageLps, isError, shouldShowDash}: LpsColumnPropsType): JSX.Element {
    const getColor = useMemo(() => {
        if (value <= 50) {
            return '#E76364';
        }

        if (value <= 80) {
            return '#F7CE4C';
        }

        return '#3DCF7B';
    }, [value]);

    const strokeColor = shouldShowDash ? cssVariablesStyles.gray7 : getColor;
    const trailColor = shouldShowDash ? cssVariablesStyles.gray4 : '';

    return (
        <Tooltip
            color={shouldShowDash ? '' : gray1}
            placement="top"
            style={shouldShowDash ? {} : {width: '400px'}}
            title={
                shouldShowDash ? (
                    <Locale stringKey="MY_COMPANIES__LPS_DASH_TOOLTIP" />
                ) : (
                    <div className={styles.LpsColumn_tooltip}>
                        <div>
                            <Locale
                                stringKey="MY_COMPANIES__LPS_TOOLTIP_DESCRIPTION_FIRST"
                                valueMap={{
                                    rating: <LpsStatus averageLps={averageLps} isError={isError} />,
                                }}
                            />
                        </div>
                        <div>
                            <Locale
                                stringKey="MY_COMPANIES__LPS_TOOLTIP_DESCRIPTION_SECOND"
                                valueMap={{
                                    recomendationLink: (
                                        <NavigationLink to={appRoute.dashboard.path}>
                                            <Locale stringKey="MY_COMPANIES__LPS_RECOMNDATION" />
                                        </NavigationLink>
                                    ),
                                }}
                            />
                        </div>
                    </div>
                )
            }
        >
            <div className={styles.LpsColumn}>
                <Progress
                    percent={value}
                    showInfo={false}
                    size={20}
                    strokeColor={strokeColor}
                    trailColor={trailColor}
                    type="circle"
                />
                <Text inheritColor={shouldShowDash}>{value}</Text>
            </div>
        </Tooltip>
    );
}
